<template>
  <!-- Fondo -->
  <transition name="fade">
    <div
      v-if="visible"
      class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center z-50"
     
    >

      <!-- Modal -->
      <div
        class="bg-white rounded-xl shadow-2xl w-full max-w-lg p-6 
               transform transition-all scale-100 border border-gray-200"
      >

        <!-- Header -->
        <div class="flex justify-between items-start border-b pb-3 mb-5">
          <div>
            <h2 class="text-xl font-semibold text-gray-800 leading-tight">
              {{ nomcta }}
            </h2>
            <p class="text-sm text-gray-500 mt-1">
            Modificar  Ingreso del mes: <span class="font-medium text-gray-700">{{ mesTexto }}</span>
            </p>
            <p>presupuesto id: {{ presupuesto_id }}</p>
            <p>borrador: {{ borrador }}</p>
          </div>

          <button
            @click="cerrar"
            class="text-gray-400 hover:text-gray-600 transition text-xl leading-none"
          >
            ✕
          </button>
        </div>

        <!-- FORMULARIO -->
        <div class="space-y-5">

          <!-- Glosa -->
          <div>
            <label class="block text-gray-600 font-medium mb-1">Glosa</label>
            <textarea
              v-model="glosa"
              placeholder="Escribe una glosa..."
              rows="3"
              class="border border-gray-300 rounded-lg px-3 py-2 w-full
                     focus:ring-2 focus:ring-blue-300 focus:border-blue-500
                     transition outline-none"
            ></textarea>
          </div>

          <!-- Monto -->
          <div>
            <label class="block text-gray-600 font-medium mb-1">Monto mensual</label>
            <input
              type="text"
              placeholder="Ej: 150.000"
              class="border border-gray-300 rounded-lg px-3 py-2 w-full
                     focus:ring-2 focus:ring-blue-300 focus:border-blue-500
                     transition outline-none font-semibold text-gray-700"
              v-model="monto_mensual"
            />
          </div>

        </div>

        <!-- Footer -->
        <div class="flex justify-end gap-3 mt-8 pt-3 border-t">

          <button
            @click="cerrar"
            class="px-4 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 
                   text-gray-700 font-medium transition"
          >
            Cancelar
          </button>

          <button
            v-if="ingresos_bloqueados == false"
            @click="guardar"
            class="px-5 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 
                   text-white font-semibold shadow-sm transition"
          >
            Guardar
          </button>

        </div>

      </div>
    </div>
  </transition>
</template>


<script>
import api from "@/api/axios";
export default {
  name: "ModalIngresoMes",
  emits: ['get_monto_mensual'],
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    
    nomcta: {
      type: String
    },
    datosIngreso: {
      type: Object
    },
    ingresos_bloqueados:{
      type: Boolean 
    
    },
    borrador:{
      type: Boolean
    }
  },
  computed: {
    mesTexto() {
      const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      return this.mes > 0 ? meses[this.mes - 1] : "";
    },
  },
  watch: {
    datosIngreso: function (v) {
      if (v && typeof v === "object" && !Array.isArray(v) && "monto_mensual" in v && "glosa" in v) {
        this.monto_mensual =  this.$formatoMiles(v.monto_mensual);
        this.glosa = v.glosa;
        this.mes = v.mes;
        this.presupuesto_id = v.presupuesto_id;
        if ("id" in v){
          this.ingreso_id = v.id;
        }

      }
    }
  },
  methods: {
    cerrar() {
      this.$emit("update:visible", false);
    },
    
    async guardar() {

      try {


        const data = {
          presupuesto_id: this.presupuesto_id,
          mes_num:        this.mes,
          ingreso_id:     this.ingreso_id,
          glosa:          this.glosa,
          monto_mensual:   this.monto_mensual 
        };

        const url = "api/v1/ingreso/";

        const resp = await api.post(
          url, data, 
          { headers: { "Content-Type": "application/json"  }  }
        );

      
        const status = resp.data.status;
        switch (status) {
          case 200:
          
            this.$emit("get_monto_mensual"  )
            this.cerrar();
            break;

        }

       

      } catch (err) {

        console.log(err);


      }








   
    },
     
  },
  data() {
    return {
      monto_mensual: 0,
      glosa: '',
      rendicion_id:0,
      mes:0
    }
  },
  mounted() {

  }
};
</script>

<style scoped></style>
